import { render } from "./SearchFilters.vue?vue&type=template&id=b96e52aa"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\fe_dev\\uob-sites\\2026\\student_accom_application_march2026\\accommodation-residences-vuejs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__